import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiContextProvidedValue, BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import BaseTierUpsell from './BaseTierUpsell';

export interface Props {
  className?: string;
}

export const WantMoreSubscribersTierUpsell: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <BaseTierUpsell
      className={className}
      imageSrc={Url.staticCDNLink('eclipse/global/svg/tier-upsell-want-more-subscribers.svg')}
      imageWidth="158px"
      title={t('deviation.tier.upsell.title.wantMoreSubscribers')}
      subtitle={t('deviation.tier.upsell.subtitle.wantMoreSubscribers')}
      buttonText={t('deviation.tier.upsell.button.wantMoreSubscribers')}
      href={t('deviation.tier.upsell.ctaUrl.wantMoreSubscribers')}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'tier.upsell.want_more_subscribers',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    />
  );
};
WantMoreSubscribersTierUpsell.displayName = 'WantMoreSubscribersTierUpsell';

export default WantMoreSubscribersTierUpsell;
